<template>
    <v-row class="ma-0 pb-offset">
        <v-col class="pa-0" cols="12">
            <v-card class="mb-2 background-2 round-card">
                <v-card-title class="pa-3">
                    <p class="pl-2 pl-xl-3">Layout di Stampa</p>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-divider></v-divider>
            
                <v-container class="pa-0" fluid>
                    <v-subheader class="pl-5">Seleziona un gruppo di layout di stampa di default</v-subheader>
                    <v-row class="pa-4 pt-0">
                        <v-col class="px-4" cols="6">
                            <v-autocomplete
                                v-model="settings['layoutgroup']"
                                :items="layoutgroups"
                                label="Gruppo Layout"
                                dense
                                small-chips
                                clearable
                                outlined
                                hide-details
                            ></v-autocomplete>
                        </v-col>
                    </v-row>
                </v-container>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text class="pa-2 mx-2" color="primary" @click.native="saveSettings">Salva</v-btn>
                </v-card-actions>
            </v-card>

            <!-- <v-col class="pa-0 bp-4">
                <file-uploader
                    :id="4"
                    attachable-type="layout"
                ></file-uploader>
            </v-col>             -->
        </v-col>
    </v-row>
</template>

<script>
    import FileUploader from '@/components/common/FileUploader'
	import SettingsOptionsMixin from '@/mixins/SettingsOptionsMixin'

	export default {
		name:'settings-print',
        components: {
            FileUploader,
        },        
		mixins: [SettingsOptionsMixin],
		data() {
			return {
				model: 'settings',
				settings: {
				    'layoutgroup': null,
                },
                layoutgroups: []
			}
		},

        methods: {
            infoSettingPrint() {
                this.axios.post('layoutgroups/', {'model': this.model}).then(response => {

                    this.layoutgroups = response.data.layoutgroups
    
                    this.axios.get('settings/'+this.model+'/layout').then(response => {
    
                        _.forEach(response.data.settings, (setting) => {
                            this.settings[setting.key] = setting.value
                        })
                        this.$store.commit('endProgress')
    
                    }, response => {
                        // error callback
                    })
                }, response => {
                    // error callback
                })
            }
        },

		created() {
			this.infoSettingPrint()
		}        
    }
</script>

<style>

</style>